import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref } from "vue";
import type { ICoursePreview, ISpeaker } from "@/types/entities/ICoursePreview";
import routesName from "@/utils/constants/routesName";
import AppLoader from "@/components/common/AppLoader.vue";
import CourseInfoPanel from "@/components/CourseInfoPanel.vue";
import CourseTabs from "@/components/CourseTabs.vue";
import CourseInformationSection from "@/components/CourseInformationSection.vue";
import CourseFacultyPanel from "@/components/CourseFacultyPanel.vue";
import { useRoute } from "vue-router";
import { CourseStatusEnum } from "@/utils/enum/CourseStatusEnum";

interface Props {
  courseData: ICoursePreview | null;
  fetching: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetails',
  props: {
    courseData: { default: null },
    fetching: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const route = useRoute();
const courseId = computed(() =>
  Number(route.params.moduleId || route.params.id)
);
const coursePreview = computed<ICoursePreview | null>(() => props.courseData);
const sortedSpeakers = computed<ISpeaker[]>(() => {
  const modules = coursePreview.value?.speakers ?? [];
  return [...modules].sort((a, b) => a.sort_order - b.sort_order);
});

const availableTabs = computed<{ id: number; name: string }[]>(() => {
  return [
    { id: 1, name: "Overview", isShow: true },
    {
      id: 2,
      name: "CME/CE Information",
      isShow: props.courseData?.information?.length,
    },
    { id: 3, name: "Faculty & Disclosures", isShow: true },
    {
      id: 4,
      name: "Instructions",
      isShow: props.courseData?.instructions?.length,
    },
  ]
    .filter((i) => i.isShow)
    .map((i) => ({ name: i.name, id: i.id }));
});
const activeTab = ref<number>(1);
const speakersRef = ref<HTMLElement | null>(null);
const openFacultyTab = (): void => {
  activeTab.value = 3;
  nextTick(() => {
    speakersRef.value?.scrollIntoView({ behavior: "smooth" });
  });
};

const tags = computed(() => coursePreview.value?.audiences);
const getSpeakerRoles = (roles: { id: number; name: string }[]): string => {
  return roles.map((r) => r.name).join("/");
};

const __returned__ = { props, route, courseId, coursePreview, sortedSpeakers, availableTabs, activeTab, speakersRef, openFacultyTab, tags, getSpeakerRoles, computed, nextTick, ref, get routesName() { return routesName }, AppLoader, CourseInfoPanel, CourseTabs, CourseInformationSection, CourseFacultyPanel, get useRoute() { return useRoute }, get CourseStatusEnum() { return CourseStatusEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})